import {useCallback} from 'react'
import {useSelectedVariantContext} from '../components/step2/context/SelectedVariantContext'
import {
    actionChangeSafeZoneImage,
    actionUpdateBackgroundImage,
} from '../components/step2/context/SelectedVariantContext/action'
import {useEditorBackground} from './useEditorBackground'

const useEditorSafeZone = () => {
    const {state, dispatch} = useSelectedVariantContext()
    const background = useEditorBackground()

    /**
     * Set Safe Zone image props
     */
    const setSafeZone = useCallback(
        (nextSafeZone) => {
            if (typeof nextSafeZone === 'function') {
                dispatch(actionChangeSafeZoneImage(nextSafeZone(state.safeZoneImage)))
            } else {
                dispatch(actionChangeSafeZoneImage(nextSafeZone))
            }
        },
        [dispatch, state.safeZoneImage],
    )

    /**
     * Clear Safe Zone image
     */
    const clearSafeZone = useCallback(
        () => dispatch(actionChangeSafeZoneImage(null)),
        [dispatch, actionChangeSafeZoneImage],
    )

    /**
     * Set Background image
     */
    const setBackground = useCallback(
        (image) => dispatch(actionUpdateBackgroundImage(image)),
        [dispatch, actionUpdateBackgroundImage],
    )

    return {
        /**
         * Safe Zone image
         */
        safeZone: state.safeZoneImage,
        /**
         * Background image
         */
        background,
        setSafeZone,
        clearSafeZone,
        setBackground,
    }
}

export default useEditorSafeZone
